import '@/styles/globals.css'
import type { AppProps } from 'next/app'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import dynamic from 'next/dynamic'
import SubmitForm from '@/components/SubmitForm'
import Head from 'next/head'

const ContactActions = dynamic(() => import('@/components/ContactActions'), {
  ssr: false,
})

export default function App({ Component, pageProps }: AppProps) {
  return (
    <>
            <Head>
              <link rel="icon" href="/icons/icon-48x48.png" type="image/png" />
              <link rel="shortcut icon" href="/icons/icon-48x48.png" type="image/png" />
              <link rel="manifest" href="/manifest.json" />
              {/* Schema.org Organization LD+JSON */}

                <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'Organization',
              name: 'Autoverwertung Xanten',
              url: 'https://www.xanten-autoverwertung.de',
              logo: 'https://www.xanten-autoverwertung.de/images/logo.png',
              email: 'info@xanten-autoverwertung.de',
              telephone: process.env.NEXT_PUBLIC_PHONE_NUMBER || '+49 16323 37268',
              contactPoint: [
                {
                  '@type': 'ContactPoint',
                  telephone: process.env.NEXT_PUBLIC_PHONE_NUMBER || '+49 16323 37268',
                  email: 'info@xanten-autoverwertung.de',
                  contactType: 'customer service',
                  areaServed: 'DE',
                  availableLanguage: ['German'],
                },
              ],
              sameAs: [
                'https://www.instagram.com/autoverwertung_coburg',
                'https://x.com/autoverwer38878',
              ],
            }),
          }}
        />
            </Head>
      <Header />
      <main>
        <ContactActions />
        <Component {...pageProps} />
      </main>

      <Footer />
    </>
  )
}
